import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import MediaAppearances from '../../../../views/Media/MediaAppearances';

const MediaRoute = () => {
    return (        
        <Routes>
            <Route path="" element={<MediaAppearances />} />
    
        </Routes>        
    );
};

export default MediaRoute;